
import { Options } from "vue-class-component";
import { email, required, confirmPassword } from "../../services/validators";
import { FormGroup } from "../../model/FormGroup.model";
import { Message } from "../../model/Message.model";
import BaseForm from "../../components/baseForm/baseForm.vue";
import { computed } from "vue";

@Options({})
export default class RegisterForm extends BaseForm {
  public msg: Message = {
    firstName: "",
    lastName: "",
    userName: "",
    email: "",
    password: "",
    confirmPassword: ""
  };

  public formGroup: FormGroup = {
    firstName: { rules: [required()], value: "" },
    lastName: { rules: [required()], value: "" },
    userName: { rules: [required()], value: "" },
    email: { rules: [email()], value: "" },
    password: { rules: [required()], value: "" },
    confirmPassword: {
      rules: [
        required(),
        confirmPassword(computed(() => this.formGroup.password.value))
      ],
      value: ""
    }
  };
}
